export default __webpack_public_path__ + "static/media/logoDark.5983323c.svg";